import { graphql } from 'src/gql';

// Shared GraphQL plumbing for "last visited the notifications inbox" —
// `visitedAt` drives the transient per-row unread bold on the bell peek and
// the v2 inbox; the mutation settles that bold to read after a dwell on the
// full inbox (not on peek-open). The action-center page defines its own
// copies inline (UNO-297-era); we keep these separate to avoid a refactor
// in the same PR — collapse to one source once the v2 dust settles.

export const notificationsVisitedQuery = graphql(/* GraphQL */ `
  query NotificationsVisited($id: ID) {
    advisor(id: $id) {
      visitedActionCenterAt
    }
  }
`);

export const updateNotificationsVisitedMutation = graphql(/* GraphQL */ `
  mutation UpdateNotificationsVisited($input: UpdateActionCenterVisitedInput!) {
    updateActionCenterVisited(input: $input) {
      success
    }
  }
`);
